import React from 'react';
import { ToggleButton } from '../../Providers/GlobalMenuStateProvider';
import { Logo, ThemeSwitcherButton } from '../Menu/Sidebar';
export default function Header({ children }) {
    return React.createElement("header", { id: "page-topbar" },
        React.createElement("div", { className: "navbar-header" },
            React.createElement("div", { className: "d-flex" },
                React.createElement("div", { className: "navbar-brand-box" },
                    React.createElement(Logo, null)),
                React.createElement(ToggleButton, null),
                React.createElement(ThemeSwitcherButton, null)),
            React.createElement("div", { className: "d-flex" }, children)));
}
